import React, { FC, useEffect, useState } from 'react';
import clsx from 'clsx';
import './style.less';

export interface PlayerHintProps {
  isShow: boolean;
}

export const PlayerHint: FC<PlayerHintProps> = props => {
  const { isShow, children } = props;
  const [isOpen, setIsOpen] = useState(isShow);
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    let to = 0;
    if (!isShow && isOpen && !isClosing) {
      setIsClosing(true);
      to = window.setTimeout(() => {
        setIsClosing(false);
        setIsOpen(false);
      }, 550);
    } else if (isShow) {
      setIsOpen(isShow);
      setIsClosing(false);
      clearTimeout(to);
    }
    return () => clearTimeout(to);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isShow]);

  const isClosed = isClosing || !isOpen;

  return (
    <div
      className={clsx('PlayerHint', isClosed ? 'PlayerHint--closed' : 'PlayerHint--open')}
    >
      {isOpen && <div className="PlayerHint__content">{children}</div>}
    </div>
  );
};
